import { SocialAuth } from '@/shared/SocialAuth';

export default defineNuxtPlugin(() => {
  const { originDomain } = useRuntimeConfig().public;

  const socialAuthInstance = SocialAuth.getInstance({
    originDomain,
  });

  return {
    provide: {
      socialAuth: socialAuthInstance,
    },
  };
});
